export const CART_LOADING = "CART_LOADING";
export const CART_ERROR = "CART_ERROR";

export const GET_CART = "GET_CART";
export const ADD_CART = "ADD_CART";
export const INC_CART = "INC_CART";
export const DEC_CART = "DEC_CART";
export const CLEAR_CART = "CLEAR_CART";
export const DELETE_ITEM_FROM_CART = "DELETE_ITEM_FROM_CART";



